module.exports = __webpack_public_path__ + "img/customers-img.fbe85526.svg";